import React, { useContext } from 'react';
import img from '../../../assets/images/process-img.png';
import AppContext from "../../../context/store";

const ProcessPage = () => {
  const context = useContext(AppContext);
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "85vh" }}>
      <div style={{ height: "500px", width: "500px" }}>
        <img src={img} alt="process-img" height={"100%"} width={"100%"} />
      </div>
      <div
        style={{
          width: "700px",
          textAlign: "center",
          color: "#2563EB",
          fontSize: "28px",
          fontWeight: "bold",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          padding: "15px",
        }}
      >
        {context.t("menuItems.newReports.process")}
        <div style={{ fontSize: "18px", color: "#4B5563", marginTop: "8px" }}>
          {context.t("menuItems.newReports.processText")}
        </div>
      </div>
    </div>
  );
};

export default ProcessPage;